export default __webpack_public_path__ + "static/media/pagination_button_right.ce963f30.svg";